<template>
  <header>
    <div class="w-screen min-h-screen grid grid-cols-1 md:grid-cols-2">
      <div
        v-if="!esMovil"
        class="
          sm:h-screen
          bg-white
          grid grid-cols-1
          place-content-center
          bg-cover bg-center bg-[url('1x/edificios.png')]
        "
      >
        <p class="text-center">
          <img src="elite/SVG/completo.svg" class="w-1/2 inline-block" />
        </p>
      </div>
      <div class="sm:h-screen bg-verde grid grid-cols-1 place-content-center">
        <p
          class="text-white text-center text-xl font-serif uppercase px-2"
          v-if="lang == 'es'"
        >
          Despacho jurídico especializado <br />
          en las principales áreas que requiere <br />
          <span class="text-dorado">el sector empresarial</span>
        </p>
        <p
          class="text-white text-center text-xl font-serif uppercase px-2"
          v-if="lang == 'en'"
        >
          Law firm specialized in <br />
          in key areas required by <br />
          <span class="text-dorado">the corporate sector</span>
        </p>
      </div>
      <div
        v-if="esMovil"
        class="
          sm:h-screen
          bg-white
          grid grid-cols-1
          place-content-center
          bg-cover bg-center bg-[url('1x/edificios.png')]
        "
      >
        <p class="text-center">
          <img src="elite/SVG/completo.svg" class="w-1/2 inline-block" />
        </p>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: "Hero",
  data() {
    return {
      lang: localStorage.getItem("lang") || "es",
      esMovil: window.innerWidth > window.innerHeight,
    };
  },
};
</script>
